import { gsap } from 'gsap/dist/gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

class HorizontalScroll {
  constructor(el) {
    this.wWidth = $(window).innerWidth();
    this.wHeight = $(window).innerHeight();
    this.$block = $(el);
    this.$container = this.$block.find('.horizontal__container');
    this.$inner = this.$block.find('.horizontal__inner');
    this.mm = gsap.matchMedia();

    this.mm.add('(max-width: 767px)', () => {
      this.width = this.$inner.outerWidth();
      this.height = this.$inner.height();
      this.createTimeline(this.$inner, this.$container, this.$inner);
    });

    this.mm.add('(min-width: 768px)', () => {
      this.width = this.$container.outerWidth();
      this.height = this.$block.outerHeight();
      this.createTimeline(this.$block, this.$block, this.$container);
    });
  }

  createTimeline($trigger, $pin, $tween) {
    this.wWidth = $(window).innerWidth();
    this.wHeight = $(window).innerHeight();

    this.timeline = gsap.timeline({
      scrollTrigger: {
        trigger: $trigger.get(0),
        start: () => {
          const offset = this.wWidth > 768 ? 50 : 0;
          let top = this.wHeight / 2 - this.height / 2 + offset;
          top = Math.round(Math.max(top, 70));
          return `top top+=${top}`;
        },
        end: () => {
          return `+=${this.width * 1.2}`;
        },
        pin: $pin.get(0),
        scrub: true,
      },
    });

    this.addTween($tween.get(0));
  }

  addTween(to) {
    this.timeline.to(to, {
      x: () => {
        const offset = Math.round(this.width - this.wWidth);
        return `-${offset}px`;
      },
      ease: 'none',
    });
  }
}

export default HorizontalScroll;
